export default defineNuxtPlugin(async () => {
    const config = useRuntimeConfig();

    if (!config.public.cookiebotEnabled) {
        return;
    }

    addCookiebotInitListener();

    addCookiebotScriptToHead(config);
});

const californiaRegionCode = 'us-06';
const addCookiebotInitListener = () => {
    window.addEventListener(
        'CookiebotOnDialogInit',
        () => {
            const userResponseSubmitted =
                window.Cookiebot.hasResponse ||
                window.Cookiebot.consented ||
                window.Cookiebot.declined;
            const userRegion = window.Cookiebot?.userCountry.toLowerCase();
            if (!userResponseSubmitted) {
                if (
                    userRegion.includes('us') &&
                    userRegion !== californiaRegionCode
                ) {
                    window.Cookiebot.submitCustomConsent(true, true, true);
                }
            }
        },
        { once: true },
    );
};

const addCookiebotScriptToHead = (config: RuntimeConfig) => {
    useHead({
        script: [
            {
                id: 'Cookiebot',
                src: 'https://consent.cookiebot.com/uc.js',
                async: true,
                'data-cbid': config.public.cookiebotUS,
                'data-blockingmode': 'manual',
                'data-georegions': `{'region':'US-06','cbid':'${config.public.cookiebotCA}'},
          {'region':'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IS,IE,IT,LV,LI,LT,LU,MT,NL,NO,PL,PT,RO,SK,SI,ES,SE,GB','cbid':'${config.public.cookiebotEU}'}`,
            },
        ],
    });
};
